import axios from 'axios';
import store from '@/store';
const ajax = axios.create({
  baseURL: (process.env.VUE_APP_BASE_URL !== undefined) ? process.env.VUE_APP_BASE_URL : '//localhost:3000/',
});

ajax.interceptors.request.use(
 (config) => {

  config.headers.Accept = 'application/json';

  if (store.state.loggedIn) {
     config.headers.Authorization = `Bearer ${ store.state.token }`;
   }

  return config;
 },

 (error) => {
   return Promise.reject(error);
 },
);

export default ajax;
